module.exports = __webpack_public_path__ + "static/img/m3_t4b_text2.fafe64a7.jpg";